import { registerLocaleData } from '@angular/common';
import localeAr from '@angular/common/locales/ar';
import localeEn from '@angular/common/locales/en';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { ensureLatestVersion } from './app/utils/ensure-latest-version';

registerLocaleData(localeAr);
registerLocaleData(localeEn);

ensureLatestVersion()
  .then(() => bootstrapApplication(AppComponent, appConfig))
  .catch((err) => console.error(err));
